<ng-template #fullCard>
  <div class="dc">
    <div class="dc-head">
      <span class="label">Boss Battle</span>
      <span class="countdown">{{ daily.countdown() }}</span>
    </div>

    <div class="dc-body">
      <span class="dc-sub ui-label">{{ daily.fieldLabel() }} · {{ daily.modeLabel() }}</span>
      <div class="dc-team">
        @for (slot of daily.bossSlots(); track slot.monId + '-' + $index) {
          <app-mon-static-sprite
            [monId]="slot.monId"
            spriteType="mini"
            [displayWidth]="48"
            [displayHeight]="48"
            [title]="slot.name" />
        }
      </div>
    </div>

    <div class="dc-foot">
      <div class="modal-btn-row">
        <button
          type="button"
          class="modal-btn modal-btn--primary modal-btn--block"
          [disabled]="!daily.canStart()"
          (click)="challenge()"
        >
          Challenge Boss
        </button>
        <button type="button" class="modal-btn modal-btn--ghost modal-btn--block" (click)="openBoard()">
          View Leaderboard
        </button>
      </div>
    </div>
  </div>
</ng-template>

@if (mobile.isMobile) {
  <button type="button" class="dc-line" (click)="showModal.set(true)">
    <app-mon-static-sprite
      [monId]="daily.encounter().leadMonId"
      spriteType="mini"
      [displayWidth]="32"
      [displayHeight]="32" />
    <span class="nm">Boss Battle</span>
    <span class="dc-sub ui-label">{{ daily.fieldLabel() }}</span>
    <span class="countdown">{{ daily.countdown() }}</span>
    <span class="chev">›</span>
  </button>

  @if (showModal()) {
    <div class="modal-overlay" (overlayDismiss)="showModal.set(false)">
      <div class="modal-shell modal-shell--narrow">
        <div class="modal-header modal-header--tight">
          <div class="modal-marquee">
            <div class="modal-marquee-track">
              <span class="modal-marquee-text">BOSS BATTLE · BOSS BATTLE · BOSS BATTLE · </span>
              <span class="modal-marquee-text">BOSS BATTLE · BOSS BATTLE · BOSS BATTLE · </span>
            </div>
          </div>
          <button type="button" class="modal-close" (click)="showModal.set(false)" aria-label="Dismiss">×</button>
        </div>
        <div class="modal-body">
          <div class="modal-section">
            <ng-container *ngTemplateOutlet="fullCard"></ng-container>
          </div>
        </div>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="fullCard"></ng-container>
}
